// extracted by mini-css-extract-plugin
module.exports = {"errors":"style_errors__1qPXG","elektropayLogo":"style_elektropayLogo__3K-j4","container":"style_container__1J5wN","footerNav":"style_footerNav__1hWJN"};